import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-preview",
  "use": "icon-preview-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-preview\">\r\n  <path d=\"M7.99967 12C11.6816 12 14.6663 8 14.6663 8C14.6663 8 11.6816 4 7.99967 4C4.31777 4 1.33301 8 1.33301 8C1.33301 8 4.31777 12 7.99967 12Z\" stroke=\"#4d7cfe\" stroke-width=\"2\" stroke-linejoin=\"round\" />\r\n  <path d=\"M7.99967 9.66732C8.92014 9.66732 9.66634 8.92112 9.66634 8.00065C9.66634 7.08018 8.92014 6.33398 7.99967 6.33398C7.07921 6.33398 6.33301 7.08018 6.33301 8.00065C6.33301 8.92112 7.07921 9.66732 7.99967 9.66732Z\" stroke=\"#4d7cfe\" stroke-width=\"2\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/preview.svg
// module id = qZ2L
// module chunks = 14